import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import { useEffect, useRef, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import MainHeading from "../../../components/comman/MainHeading";
import FilterComponent from "../../../components/comman/FilterComponent";
import CommonTable from "../../../components/comman/CommonTable";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import ViewIcon from "../../../components/Icons/ViewIcon";

export default function CustomerLedger() {
  const navigate = useNavigate();
  const timeoutId = useRef(null);
  const [filterGstOnly, setFilterGstOnly] = useState(false);
  const [filterContactOnly, setFilterContactOnly] = useState(false);
  const [filterBillingOnly, setFilterBillingOnly] = useState(false);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    CustomerLedgerData: [],
    searchQuery: "",
  });

  useEffect(() => {
    GetCustomerLedgerList(pageStates?.currentPage);
  }, [pageStates?.currentPage, pageStates?.searchQuery, pageStates?.pageSize]);

  const hasBillingFields = (item) => {
    return (
      Number(item?.invoiceAmount) > 0 ||
      Number(item?.outstandingDueVal) > 0 ||
      Number(item?.pendingAmount) > 0 ||
      Number(item?.receivedAmount) > 0 ||
      Number(item?.totalInvoiceAmount) > 0 ||
      Number(item?.billingAmount) > 0
    );
  };

  const GetCustomerLedgerList = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.get_customer + "?" + MainFilterHandler(pageStates);
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
      CustomerLedgerData: [],
    }));
    callApi(API, options).then((response) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (response?.status === true) {
        const newData = response?.data?.customer?.map((item) => ({
          ...item,
          siteStatus: item?.status,
        }));
        setPageStates((prevStates) => ({
          ...prevStates,
          CustomerLedgerData: newData,
          count: response?.data?.pageInfo?.total,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  const HandleView = (data) => {
    navigate(RoutesLink.customer_ledger_detail + `/${data?.id}`, { state: data });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Customer Name" },
    { value: "email", label: "Email" },
    { value: "phone", label: "Contact No." },
    { value: "gstNumber", label: "GSTIN" },
    { value: "siteStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "edit",
      clickHandler: HandleView,
    }
  ];

  const displayData = Array.isArray(pageStates?.CustomerLedgerData)
    ? pageStates.CustomerLedgerData.filter(item => {
        if (filterGstOnly && (!item?.gstNumber || item?.gstNumber === "")) return false;
        if (filterContactOnly && !item?.email && !item?.phone) return false;
        if (filterBillingOnly && !hasBillingFields(item)) return false;
        return true;
      })
    : [];

  return (
    <>
      <div className="content container-fluid">
        <MainHeading
          title={"Customer Ledger"}
        />

        {/* Customer Table Card */}
        <div className="card mb-4 shadow-sm border-0" style={{ borderRadius: "12px", overflow: "hidden" }}>
          <div className="card-body p-4">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
              <FilterComponent handleSearch={handleSearchChange} />
             
            </div>
            <CommonTable
              TableHeading={TableHeading}
              TableData={displayData}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates?.pageSize}
            />
          </div>
        </div>
      </div>
    </>
  );
}
